/*
  Add here your own custom javascript codes
*/
$('.tab_head').on('click', function(e) {
  e.preventDefault();
  $('.tab_head').removeClass('active');
  $(this).addClass('active');
  var col = $(this).attr('data-col');
  $('.tab_body').removeClass('active');
  $('.tab_body[data-col="'+col+'"]').addClass('active');
})


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $("#navbar-wrapper").addClass("sticky");
    } else {
        $("#navbar-wrapper").removeClass("sticky");
    }
});